<template>
  <div class="flex-row align-center just-between">
    <QuickFilterItem
      label="Pending"
      filterItem="pending"
      :count="serviceSummary.pending"
      :active="active === 'pending'"
      :activeColor="'#F83356'"
      imageSrc="siren"
      :toggle="toggle"
      :loading="loadingSummary"
    />
    <QuickFilterItem
      label="Snoozed"
      filterItem="snoozed"
      :count="serviceSummary.snoozed"
      :active="active === 'snoozed'"
      :activeColor="'#434D6A'"
      imageSrc="bell"
      :toggle="toggle"
      :loading="loadingSummary"
    />
    <QuickFilterItem
      label="Scheduled"
      filterItem="scheduled"
      :count="serviceSummary.scheduled"
      :active="active === 'scheduled'"
      :activeColor="'#66D383'"
      activeTextColor="n110"
      imageSrc="calendar"
      :toggle="toggle"
      :loading="loadingSummary"
    />
    <QuickFilterItem
      label="Incomplete"
      filterItem="incomplete"
      :count="serviceSummary.incomplete"
      :active="active === 'incomplete'"
      :activeColor="'#727A8F'"
      imageSrc="toggle"
      :toggle="toggle"
      :loading="loadingSummary"
    />
    <QuickFilterItem
      label="Closed"
      subLabel="As of Last 7 days"
      filterItem="closed"
      :count="serviceSummary.closed"
      :active="active === 'closed'"
      :activeColor="'#A1A6B5'"
      activeTextColor="n110"
      imageSrc="check"
      :toggle="toggle"
      :loading="loadingSummary"
    />
  </div>
</template>

<script>
import serviceMixin from '@shared/mixins/serviceMixin';

import QuickFilterItem from './serviceQuickFilter/QuickFilterItem.vue';

export default {
  name: 'ServiceQuickFilters',
  components: {
    QuickFilterItem,
  },
  mixins: [serviceMixin],
  props: {
    active: String,
    toggle: Function,
  },
};
</script>
